/* prettier-ignore */
export var colorsClassesMap = {
  secondary_button_10: 'color_secondary_button_10',
  superblack_40: 'color_superblack_40',
  superblack_60: 'color_superblack_60',
  superblack_10: 'color_superblack_10',
  superblack_100: 'color_superblack_100',
  superblack_20: 'color_superblack_20',
  superblack_6: 'color_superblack_6',
  success_100: 'color_success_100',
  success_10: 'color_success_10',
  error_100: 'color_error_100',
  error_10: 'color_error_10',
  sokolniki_100: 'color_sokolniki_100',
  fill_primary_active_100: 'color_fill_primary_active_100',
  zamoskvoreckaya_100: 'color_zamoskvoreckaya_100',
  fill_error_primary_active_100: 'color_fill_error_primary_active_100',
  arbatskaya_100: 'color_arbatskaya_100',
  fill_success_secondary_active_20: 'color_fill_success_secondary_active_20',
  filevskaya_100: 'color_filevskaya_100',
  kolcevaia_100: 'color_kolcevaia_100',
  fill_primary_hover_100: 'color_fill_primary_hover_100',
  rijckaya_100: 'color_rijckaya_100',
  fill_secondary_active_30: 'color_fill_secondary_active_30',
  taganskaya_100: 'color_taganskaya_100',
  fill_success_primary__active_100: 'color_fill_success_primary__active_100',
  colncevo_100: 'color_colncevo_100',
  fill_success_primary__hover_100: 'color_fill_success_primary__hover_100',
  temirazevskaya_100: 'color_temirazevskaya_100',
  fill_error_secondary__active_20: 'color_fill_error_secondary__active_20',
  lublino_100: 'color_lublino_100',
  fill_error_secondary_hover_16: 'color_fill_error_secondary_hover_16',
  big_kolcevaya_100: 'color_big_kolcevaya_100',
  fill_error_primary_hover_100_: 'color_fill_error_primary_hover_100_',
  butovo_100: 'color_butovo_100',
  monorels_100: 'color_monorels_100',
  fill_success_secondary_hover_16: 'color_fill_success_secondary_hover_16',
  mck_100: 'color_mck_100',
  fill_secondary_hover_20: 'color_fill_secondary_hover_20',
  kommynarskaya_100: 'color_kommynarskaya_100',
  gray_icons_100: 'color_gray_icons_100',
  black_icons_60: 'color_black_icons_60',
  black_control_80: 'color_black_control_80',
  white_icons_60: 'color_white_icons_60',
  warning_100: 'color_warning_100',
  warning15_100: 'color_warning15_100',
  focused_15: 'color_focused_15',
  black_100: 'color_black_100',
  primary_100: 'color_primary_100',
  primary_10: 'color_primary_10',
  gray60_100: 'color_gray60_100',
  gray40_100: 'color_gray40_100',
  gray20_100: 'color_gray20_100',
  gray10_100: 'color_gray10_100',
  gray6_100: 'color_gray6_100',
  black_60: 'color_black_60',
  black_40: 'color_black_40',
  black_20: 'color_black_20',
  black_10: 'color_black_10',
  black_6: 'color_black_6',
  white_100: 'color_white_100',
  white_60: 'color_white_60',
  white_40: 'color_white_40',
  white_10: 'color_white_10',
  white_20: 'color_white_20',
  white_6: 'color_white_6',
  fill_white_secondary_30: 'color_fill_white_secondary_30',
  current_color: 'color_current_color'
};